"use strict";

var _createClass = require("/home/runner/work/mono-marketplace-hub-ui/mono-marketplace-hub-ui/node_modules/@babel/runtime/helpers/createClass.js");
var _classCallCheck = require("/home/runner/work/mono-marketplace-hub-ui/mono-marketplace-hub-ui/node_modules/@babel/runtime/helpers/classCallCheck.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var ValidationResult = /*#__PURE__*/_createClass(function ValidationResult(isValid) {
  var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  _classCallCheck(this, ValidationResult);
  this.isValid = isValid;
  this.message = message;
});
exports.default = ValidationResult;